import {connect} from 'react-redux';
import {denormalize} from 'normalizr';

import {schema} from '../../../../../state/schema';
import {loadImportJobs} from '../../../../../state/modules/imports/actions';
import {sendMessage} from '../../../../../state/actions';
import JobsList from '../components/JobsList';

const mapStateToProps = (state, ownProps) => {

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;
  const result = state.imports.getIn(['pages', order, limit, page]);

  return {
    list: result 
      ? result.map(x => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['importJobs', x]),
              schema.plan,
              state.entities.toJS()
            )
          };
        }).toArray()
      : [],
    isLoading: state.imports.get('isLoading'),
    total: state.imports.get('total'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (page, limit, order, filter, cb) => {
      dispatch(loadImportJobs(page, limit, order, filter, cb));
    },
    sendMessage: (level, title, body, expires) => {
      dispatch(sendMessage(level, title, body, expires));
    },
  }
}

const JobsListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(JobsList);

export default JobsListContainer;
